import {VehicleNameEnum} from '@/services/api-clients';
import i18n from '@/i18n/config';
import {LF} from '@/i18n/LF';

export function vehicleNameFilter(value: VehicleNameEnum): string {
  switch (value) {
    case VehicleNameEnum.ToyotaYaris: return 'Toyota Yaris';
    case VehicleNameEnum.ToyotaAygo: return 'Toyota Aygo';
    case VehicleNameEnum.ToyotaCorolla: return 'Toyota Corolla';
    case VehicleNameEnum.ToyotaYarisCross: return 'Toyota Yaris Cross';
    case VehicleNameEnum.ToyotaCHR: return 'Toyota C-HR';
    case VehicleNameEnum.Duotts: return 'Duotts';
    case VehicleNameEnum.FunBike: return 'Funbike';
    case VehicleNameEnum.RavapiBike: return 'Ravapi ' + i18n.t(LF.Bike) as string;
    case VehicleNameEnum.Indiana: return 'Indiana';
    case VehicleNameEnum.Kross: return 'Kross';
    case VehicleNameEnum.MultiCycle: return 'Multicycle';
    case VehicleNameEnum.OneSport: return 'One sport';
    case VehicleNameEnum.Overfly: return 'Overfly';
    case VehicleNameEnum.HusarE: return 'Husar ' + i18n.t(LF.EBike) as string;
    case VehicleNameEnum.Husar: return 'Husar';
    case VehicleNameEnum.Hogan: return 'Hogan';
    case VehicleNameEnum.RockRider: return 'Rockrider';
    case VehicleNameEnum.HondaPCX: return 'Honda PCX';
    case VehicleNameEnum.HondaVision: return 'Honda Vision';
    case VehicleNameEnum.HopCity: return 'Hopcity';
    case VehicleNameEnum.Amperi: return 'Amperi';
  }
}
